var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.831,
    height: 52.788,
    viewBox: "0 0 42.831 52.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1129",
    "data-name": "\\uADF8\\uB8F9 1129",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-shield",
    "data-name": "Icon feather-shield",
    d: "M25.915,52.788s19.915-9.958,19.915-24.894V10.468L25.915,3,6,10.468V27.894C6,42.831,25.915,52.788,25.915,52.788Z",
    transform: "translate(-6 -3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M19.327,10.427h-6.69V3.737A1.487,1.487,0,0,0,11.15,2.25H9.663A1.487,1.487,0,0,0,8.177,3.737v6.69H1.487A1.487,1.487,0,0,0,0,11.913V13.4a1.487,1.487,0,0,0,1.487,1.487h6.69v6.69a1.487,1.487,0,0,0,1.487,1.487H11.15a1.487,1.487,0,0,0,1.487-1.487v-6.69h6.69A1.487,1.487,0,0,0,20.813,13.4V11.913A1.487,1.487,0,0,0,19.327,10.427Z",
    transform: "translate(9.509 12.237)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.fb454e764a0f95231d364398f9f4663d.svg";
export { ForwardRef as ReactComponent };